import React, { useEffect, useContext } from 'react';
import { Card } from '@common';

import CardFiltersProvider from 'components/specific/CardFilters/context/filters-context';
import { CardFiltersContext } from 'components/specific/CardFilters/context/filters-context';
import VisitsChart from '../../../components/common/vsitsChart/VisitsChart';

export const VisitChart = ({
  totalVisit,
  totalVisitCount,
  setVisit,
  setLocalfiltersVisit,
}) => {
  return (
    <CardFiltersProvider>
      <VisitCharts
        setLocalfiltersVisit={setLocalfiltersVisit}
        totalVisit={totalVisit}
        totalVisitCount={totalVisitCount}
        setVisit={setVisit}
      />
    </CardFiltersProvider>
  );
};

function VisitCharts({
  totalVisit,
  totalVisitCount,
  setVisit,
  setLocalfiltersVisit,
}) {
  const { state, dispatch, date } = useContext(CardFiltersContext);

  console.log('totalPractopSpecialties', state);

  function formatObject(inputObj) {
    const formattedKey = inputObj.title.toUpperCase(); // Convert title to uppercase
    const selectedList = inputObj.selectedList;

    // Extract the key-value pairs from the selectedList
    const formattedList = Object.entries(selectedList).map(([name, _id]) => ({
      _id,
      name,
    }));

    // Return the object in the desired format
    return {
      [formattedKey]: formattedList,
    };
  }

  useEffect(() => {
    let resultForParent = {};
    state.forEach((state) => {
      resultForParent = {
        ...resultForParent,
        ...formatObject(state),
        local: true,
      };
    });

    setLocalfiltersVisit(resultForParent, date.dateState);
  }, [
    ...state.flatMap((item) => Object.entries(item.selectedList).length),
    date.dateState,
  ]);

  return (
    <VisitsChart
      state={state}
      dispatch={dispatch}
      date={date}
      totalVisit={totalVisit}
      totalVisitCount={totalVisitCount}
      setVisit={setVisit}
    ></VisitsChart>
  );
}
